import React, { useState, useEffect, useRef } from 'react';
import _get from 'lodash/get';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import IconPencil from 'cccisd-icons/pencil';
import Loader from 'cccisd-loader';
import Modal from 'cccisd-modal';
import Tooltip from 'cccisd-tooltip';
import { isSupervisorViewing } from '../../../helpers/helpers';

const NOTES_DEPLOYMENT_HANDLE = 'tfh_instructor_notes';

const Notes = ({ family, familyName, isStartOpen }) => {
    // need state so only 1 DeploymentPlayer is mounted on the page at a time
    const [isOpen, setIsOpen] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        if (isStartOpen && modalRef.current) {
            modalRef.current.open();
        }
    }, [isStartOpen, modalRef]);

    const pawnId = _get(family, 'descendantRoles.metricspawn.pawn.pawnId');
    const pawnHash = _get(family, 'descendantRoles.metricspawn.pawn.pawnHash');

    const trigger = (
        <button type="button" className="btn btn-sm btn-secondary">
            <Tooltip title="Notes">
                <IconPencil />
            </Tooltip>
        </button>
    );

    return (
        <Modal
            ref={modalRef}
            title={`Notes - ${familyName}`}
            trigger={trigger}
            beforeShow={() => setIsOpen(true)}
            afterClose={() => setIsOpen(false)}
            size="large"
            render={({ closeModal }) => {
                if (!isOpen) {
                    return <Loader type="inline" loading />;
                }

                return (
                    <DeploymentPlayer
                        disableLayout
                        deploymentHandle={NOTES_DEPLOYMENT_HANDLE}
                        pawnId={pawnId}
                        pawnHash={pawnHash}
                        flowProps={{
                            familyGroupId: family.group.groupId,
                            familyGroupHash: family.group.randomHash,
                            ...(isSupervisorViewing() ? { isPrintMode: true } : {}),
                        }}
                    />
                );
            }}
        />
    );
};

export default Notes;
